// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgInstagramOutline: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M11.997 6.484A5.508 5.508 0 0 0 6.481 12a5.508 5.508 0 0 0 5.516 5.516A5.508 5.508 0 0 0 17.513 12a5.508 5.508 0 0 0-5.516-5.516m0 9.1A3.592 3.592 0 0 1 8.412 12a3.592 3.592 0 0 1 3.585-3.585A3.592 3.592 0 0 1 15.582 12a3.592 3.592 0 0 1-3.585 3.585M17.74 4.974c-.713 0-1.288.575-1.288 1.288 0 .713.575 1.288 1.288 1.288a1.285 1.285 0 0 0 1.19-1.781 1.285 1.285 0 0 0-1.19-.795M22.749 12c0-1.485.013-2.956-.07-4.437-.083-1.722-.476-3.25-1.735-4.508-1.261-1.261-2.786-1.65-4.507-1.734-1.484-.084-2.955-.07-4.437-.07-1.485 0-2.956-.014-4.437.07-1.722.083-3.25.476-4.508 1.734-1.261 1.262-1.65 2.786-1.734 4.508-.084 1.484-.07 2.955-.07 4.437 0 1.482-.014 2.956.07 4.437.083 1.721.476 3.25 1.734 4.508 1.262 1.261 2.786 1.65 4.508 1.734 1.484.084 2.955.07 4.437.07 1.484 0 2.955.014 4.437-.07 1.721-.083 3.249-.476 4.507-1.734 1.262-1.262 1.652-2.786 1.735-4.508.086-1.481.07-2.953.07-4.437m-2.367 6.341c-.196.49-.433.856-.812 1.232a3.44 3.44 0 0 1-1.232.812c-1.414.562-4.773.436-6.34.436-1.569 0-4.93.126-6.345-.433a3.417 3.417 0 0 1-1.232-.812 3.44 3.44 0 0 1-.812-1.232c-.56-1.417-.433-4.776-.433-6.344 0-1.568-.126-4.93.433-6.344.197-.49.433-.855.812-1.232a3.49 3.49 0 0 1 1.232-.812c1.415-.56 4.776-.433 6.344-.433 1.568 0 4.93-.126 6.344.433.49.196.855.433 1.232.812.379.38.616.742.812 1.232.56 1.414.433 4.776.433 6.344 0 1.568.126 4.927-.436 6.341" />
      </g>
    </svg>
  );
};

const Memo = memo(SvgInstagramOutline);
export default Memo;
